export default __webpack_public_path__ + "static/media/lemontbotanique_xl2.93658973.png";